/* eslint-disable prefer-arrow-callback */
/* eslint-disable func-names */

$.fn.extend({
  updateEplanForms() {
    this
      .filter(':not(.updateEplanForms--finished)')
      .each(function () {
        $(this)
          .addClass('updateEplanForms--finished')
          .on('submit', function () {
            $(this)
              .css({ opacity: 0.5 })
              .addClass('submitted')
              .find('input, select, textarea')
              .attr('readonly', 'readonly');

            $(this).trigger('submit');

            return false;
          })
          .each(function () {
            const action = $(this)
              .attr('action')
              .replace(/([a-z]+)(\?.+)$/gi, '$1/$2');

            $(this).attr('action', action);
          });
      });
  }
});

$('.eplan_form > form').updateEplanForms();
